import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, UsersRound, Hash, ShieldAlert, Share2, FileWarning, Radio } from 'lucide-react';
import { wl } from './theme';

const ITEMS = [
  { href: '/app/watchlist', label: 'Overview', icon: LayoutDashboard, exact: true },
  { href: '/app/watchlist/profiles', label: 'Profiles', icon: UsersRound },
  { href: '/app/watchlist/keywords', label: 'Keyword sets', icon: Hash },
  { href: '/app/watchlist/impersonation', label: 'Impersonation', icon: ShieldAlert },
  { href: '/app/watchlist/operators', label: 'Operators', icon: Share2 },
  { href: '/app/watchlist/takedowns', label: 'Takedowns', icon: FileWarning },
  { href: '/app/watchlist/sources', label: 'Sources & alerts', icon: Radio },
];

export function WatchlistSubNav() {
  const location = useLocation();

  return (
    <div className="flex items-center gap-1 mb-5 overflow-x-auto pb-1" style={{ borderBottom: `1px solid ${wl.border}`, fontFamily: wl.font }}>
      {ITEMS.map((item) => {
        const active = item.exact
          ? location.pathname === item.href
          : location.pathname.startsWith(item.href);
        const Icon = item.icon;
        return (
          <Link
            key={item.href}
            to={item.href}
            className="flex items-center gap-2 px-3.5 py-2.5 whitespace-nowrap transition-colors flex-shrink-0"
            style={{
              color: active ? wl.green : wl.textMuted,
              background: active ? wl.greenWash : 'transparent',
              borderBottom: `2px solid ${active ? wl.green : 'transparent'}`,
              fontWeight: active ? 700 : 500,
              fontSize: 12.5,
              letterSpacing: '0.02em',
            }}
          >
            <Icon size={14} />
            {item.label}
          </Link>
        );
      })}
    </div>
  );
}
